"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadAvailabilitiesAndTimeOffs = void 0;
const moment_1 = __importDefault(require("moment"));
const add_error_1 = __importDefault(require("../ac/add-error"));
const action_1 = require("../action");
const request_1 = require("../request");
const store_1 = __importDefault(require("../store"));
const is_loading_1 = __importDefault(require("./is-loading"));
const create_ac_1 = require("./util/create-ac");
exports.loadAvailabilitiesAndTimeOffs = (0, create_ac_1.createAC2)(async (dispatch, period, options) => {
    const { 
    // priority of these 4 props:
    // - is user is set, it's used
    // - then, if usersForTimeOffs or usersForTimeAvailabilities is set, we use that (depending on the query)
    // - if none of those are set, we use users
    user, usersForTimeOffs, usersForTimeAvailabilities, users, dontLoadAvailabilities, dontLoadTimeOffs, } = options;
    const { auth, workspaceId } = store_1.default.getState();
    if (!workspaceId || !period)
        return;
    await dispatch((0, is_loading_1.default)('load-availabilities-and-time-offs'));
    // get the unavs for the period from BE
    const resultAvails = !dontLoadAvailabilities
        ? user
            ? await (0, request_1.requestAvailabilitiesUser)({
                user,
                workspace: workspaceId,
                period,
            }, auth)
            : await (0, request_1.requestAvailabilitiesWorkspace)({
                workspace: workspaceId,
                period,
                // @ts-expect-error
                users: usersForTimeAvailabilities || users,
            }, auth)
        : [];
    // get the timeOffs for the period from BE
    const resultTimeOffs = !dontLoadTimeOffs
        ? user
            ? await (0, request_1.requestTimeOffsUser)({
                user,
                workspace: workspaceId,
                period,
            }, auth)
            : await (0, request_1.requestTimeOffsWorkspace)({
                workspace: workspaceId,
                period,
                users: usersForTimeOffs || users,
            }, auth)
        : [];
    if (resultAvails.error) {
        dispatch((0, add_error_1.default)(resultAvails.error));
    }
    else if (resultTimeOffs.error) {
        dispatch((0, add_error_1.default)(resultTimeOffs.error));
    }
    else {
        // keep the store availability/timeOff records that are not from requested period
        const availabilitiesOutsidePeriod = store_1.default
            .getState()
            .availabilities.filter((rec) => (0, moment_1.default)(rec?.period?.start).isBefore(period.start) ||
            (0, moment_1.default)(rec?.period?.start).isAfter(period.end));
        const timeOffsOutsidePeriod = store_1.default
            .getState()
            .timeOffs.filter((rec) => (0, moment_1.default)(rec?.period?.start).isBefore(period.start) ||
            (0, moment_1.default)(rec?.period?.start).isAfter(period.end));
        // and replace the requested period by the request results + save the new arrays to store
        await dispatch((0, action_1.setAvailabilities)(availabilitiesOutsidePeriod.concat(resultAvails || [])));
        await dispatch((0, action_1.setTimeOffs)(timeOffsOutsidePeriod.concat(resultTimeOffs || [])));
    }
    await dispatch((0, is_loading_1.default)('load-availabilities-and-time-offs', true));
    return (resultAvails.error || resultTimeOffs.error || resultAvails.concat(resultTimeOffs));
});
// export default (period, options = {}) => {
//   return async (dispatch) => {
//     const {
//       // priority of these 4 props:
//       // - is user is set, it's used
//       // - then, if usersForTimeOffs or usersForTimeAvailabilities is set, we use that (depending on the query)
//       // - if none of those are set, we use users
//       user,
//       usersForTimeOffs,
//       usersForTimeAvailabilities,
//       users,
//       dontLoadAvailabilities,
//       dontLoadTimeOffs,
//     } = options
//     const { auth, workspaceId } = store.getState()
//     if (!workspaceId || !period) return
//     await dispatch(isLoading('load-availabilities-and-time-offs'))
//     // get the unavs for the period from BE
//     const resultAvails = !dontLoadAvailabilities
//       ? user
//         ? await requestAvailabilitiesUser(
//             {
//               user,
//               workspace: workspaceId,
//               period,
//             },
//             auth
//           )
//         : await requestAvailabilitiesWorkspace(
//             {
//               workspace: workspaceId,
//               period,
//               users: usersForTimeAvailabilities || users,
//             },
//             auth
//           )
//       : []
//     // get the timeOffs for the period from BE
//     const resultTimeOffs = !dontLoadTimeOffs
//       ? user
//         ? await requestTimeOffsUser(
//             {
//               user,
//               workspace: workspaceId,
//               period,
//             },
//             auth
//           )
//         : await requestTimeOffsWorkspace(
//             {
//               workspace: workspaceId,
//               period,
//               users: usersForTimeOffs || users,
//             },
//             auth
//           )
//       : []
//     if (resultAvails.error) {
//       dispatch(addError(resultAvails.error))
//     } else if (resultTimeOffs.error) {
//       dispatch(addError(resultTimeOffs.error))
//     } else {
//       // keep the store availability/timeOff records that are not from requested period
//       const availabilitiesOutsidePeriod = store
//         .getState()
//         .availabilities.filter(
//           (rec) =>
//             moment(rec?.period?.start).isBefore(period.start) ||
//             moment(rec?.period?.start).isAfter(period.end)
//         )
//       const timeOffsOutsidePeriod = store
//         .getState()
//         .timeOffs.filter(
//           (rec) =>
//             moment(rec?.period?.start).isBefore(period.start) ||
//             moment(rec?.period?.start).isAfter(period.end)
//         )
//       // and replace the requested period by the request results + save the new arrays to store
//       await dispatch(
//         setAvailabilities(availabilitiesOutsidePeriod.concat(resultAvails || []))
//       )
//       await dispatch(setTimeOffs(timeOffsOutsidePeriod.concat(resultTimeOffs || [])))
//     }
//     await dispatch(isLoading('load-availabilities-and-time-offs', true))
//     return (
//       resultAvails.error ||
//       resultTimeOffs.error ||
//       resultAvails.concat(resultTimeOffs)
//     )
//   }
// }
exports.default = exports.loadAvailabilitiesAndTimeOffs;
